<app-component-html-template
  [(relevantAnalysisTypes)]="relevantAnalysisTypes"
  [packagingComponent]="inlay"
  [form]="form"
  [componentSubtypes]="componentSubtypes"
  [packagingComponentType]="packagingComponentType.Inlay"
  [callerId]="callerId"
  [isPreview]="isPreview"
  [isTracked]="isTracked"
  [isFormLocked]="isFormLocked"
  [historyVersions]="historyVersions"
  [spinnerActive]="spinnerActive"
  [canEditForm]="canEditForm"
  [isUserValidator]="isUserValidator"
  [isEditPermitted]="isEditPermitted"
  [imageSource]="imageSource"
  [componentTypeSelectionLabel]="'component.fields.ofInlay' | transloco"
  [isInternallyTracked]="isInternallyTracked"
  [isDataExchangeSubRequest]="isDataExchangeSubRequest"
  (historicVersionChanged)="onHistoryVersionChange($event)"
  (versionRenamed)="changeInlayVersionName($event)"
  [isInOngoingDataExchange]="isInOngoingDataExchange"
  [isCreatingDataExchangeRequest]="isCreatingDataExchangeRequest()"
  [subRequestInfo]="subRequestInfo"
  (commentAdded)="onSubRequestCommentAdded($event)"
  (submitted)="onComponentSubmit($event)"
  (finishSubRequestClicked)="onFinishSubRequest($event)"
  (approveSubRequestClicked)="onApproveSubRequest()"
  (reopenSubRequestClicked)="onReopenSubRequest()"
  (createDataExchangeRequestClicked)="createDataExchangeRequest($event)"
  (historicVersionClicked)="loadHistoryVersions(inlay.id)"
  (historicVersionChanged)="onHistoryVersionChange($event)"
  (versionRenamed)="changeInlayVersionName($event)">
  <h1 header>{{ 'component.inlay' | transloco }}</h1>

  <div doc>
    <app-doc-upload-section [(areaDto)]="inlay.docArea" [isEditable]="canEditForm" [ppwrRelevant]="relevantAnalysisTypes.ppwrRelevant"> </app-doc-upload-section>
  </div>

  <div image>
    <app-image-upload [canEditForm]="canEditForm" [images]="inlay.images" (filesEdited)="onFilesEdited()"> </app-image-upload>
  </div>

  <div certificate>
    <app-certificate-upload [canEditForm]="canEditForm" [certificates]="inlay.certificates" [certificateTypes]="allCertificateTypes" (filesEdited)="onFilesEdited()">
    </app-certificate-upload>
  </div>

  <div pdf>
    <app-pdf-upload [canEditForm]="canEditForm" [pdfs]="inlay.documents" (filesEdited)="onFilesEdited()"> </app-pdf-upload>
  </div>
</app-component-html-template>
